import React, { useState, useEffect } from 'react';
import { 
  Sparkles, 
  Layers, 
  GitMerge, 
  FileCheck, 
  Calendar, 
  CreditCard, 
  Send 
} from 'lucide-react';
import AdmissionsHeroForm from './AdmissionsHeroForm';
import AdmissionsLevelsForm from './AdmissionsLevelsForm';
import AdmissionsProcessForm from './AdmissionsProcessForm';
import AdmissionsRequirementsForm from './AdmissionsRequirementsForm';
import AdmissionsKeyDatesForm from './AdmissionsKeyDatesForm';
import AdmissionsFeesPaymentForm from './AdmissionsFeesPaymentForm';
import AdmissionsOnlineApplicationForm from './AdmissionsOnlineApplicationForm';
import './FormsUnified.css';

export default function AdmissionsForm({ apiBase, activeTab }) {
  const [currentSection, setCurrentSection] = useState('hero');

  useEffect(() => {
    if (activeTab === 'cms-adm-hero' || activeTab === 'hero') {
      setCurrentSection('hero');
    } else if (activeTab === 'cms-adm-levels' || activeTab === 'levels' || activeTab === 'pathways') {
      setCurrentSection('levels');
    } else if (activeTab === 'cms-adm-process' || activeTab === 'process') {
      setCurrentSection('process');
    } else if (activeTab === 'cms-adm-requirements' || activeTab === 'requirements' || activeTab === 'admissions-requirements') {
      setCurrentSection('requirements');
    } else if (activeTab === 'cms-adm-timeline' || activeTab === 'timeline' || activeTab === 'dates' || activeTab === 'admissions-key-dates') {
      setCurrentSection('timeline');
    } else if (activeTab === 'cms-adm-fees' || activeTab === 'fees' || activeTab === 'admissions-fees-payment') {
      setCurrentSection('fees');
    } else if (activeTab === 'cms-adm-online-app' || activeTab === 'online-app' || activeTab === 'application' || activeTab === 'admissions-online-application') {
      setCurrentSection('online-app');
    }
  }, [activeTab]);

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'hero' ? 'active' : ''}`}
          onClick={() => setCurrentSection('hero')}
        >
          <Sparkles className="w-4 h-4 mr-2" />
          <span>Hero Banner</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'levels' ? 'active' : ''}`}
          onClick={() => setCurrentSection('levels')}
        >
          <Layers className="w-4 h-4 mr-2" />
          <span>Admission Levels</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'process' ? 'active' : ''}`}
          onClick={() => setCurrentSection('process')}
        >
          <GitMerge className="w-4 h-4 mr-2" />
          <span>Application Process</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'requirements' ? 'active' : ''}`}
          onClick={() => setCurrentSection('requirements')}
        >
          <FileCheck className="w-4 h-4 mr-2" />
          <span>Requirements</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'timeline' ? 'active' : ''}`}
          onClick={() => setCurrentSection('timeline')}
        >
          <Calendar className="w-4 h-4 mr-2" />
          <span>Key Dates</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'fees' ? 'active' : ''}`}
          onClick={() => setCurrentSection('fees')}
        >
          <CreditCard className="w-4 h-4 mr-2" />
          <span>Fees & Payment</span>
        </button>

        <button
          type="button"
          className={`tab-pill-btn ${currentSection === 'online-app' ? 'active' : ''}`}
          onClick={() => setCurrentSection('online-app')}
        >
          <Send className="w-4 h-4 mr-2" />
          <span>Online Application</span>
        </button>
      </div>

      {/* Render Active Section Form */}
      <div className="unified-tab-content">
        {currentSection === 'hero' && <AdmissionsHeroForm apiBase={apiBase} />}
        {currentSection === 'levels' && <AdmissionsLevelsForm apiBase={apiBase} />}
        {currentSection === 'process' && <AdmissionsProcessForm apiBase={apiBase} />}
        {currentSection === 'requirements' && <AdmissionsRequirementsForm apiBase={apiBase} />}
        {currentSection === 'timeline' && <AdmissionsKeyDatesForm apiBase={apiBase} />}
        {currentSection === 'fees' && <AdmissionsFeesPaymentForm apiBase={apiBase} />}
        {currentSection === 'online-app' && <AdmissionsOnlineApplicationForm apiBase={apiBase} />}
      </div>
    </div>
  );
}
